export { default } from './getFirstDayOfWeek';
